// material-ui
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project imports
import Notification from './Notification';
import useConfig from 'hooks/useConfig';
import { MenuOrientation } from 'config';
import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';

// ==============================|| HEADER - CONTENT ||============================== //
//
// Observação: no desktop a navbar foi removida (ver `layout/Dashboard/index.tsx`).
// Notificações e cronômetro de sessão agora vivem no rodapé da sidebar.
// O `HeaderContent` só é renderizado no mobile, onde mantém o `MobileSection`
// (toggle do drawer + locale + timer compacto).

export default function HeaderContent() {
  const { menuOrientation } = useConfig();
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      <Box sx={{ flexGrow: 1 }} />
      {/* No header estreito (downLG), o sino de notificações no lugar do antigo
          menu de 3 pontos (MobileSection). */}
      {downLG && <Notification />}
    </>
  );
}
